module.exports = __webpack_public_path__ + "static/media/storyKeeper.d0beff30.png";